export default {
    body: '#fff',
    text: '#000',
    accent: '#0063f9',
    highlight: 'rgba(53, 255, 240, 0.45)',
}
